import gql from "graphql-tag";
import {getTrialRemainingDays, getTrialStatus, isTrialUnlimited} from "~/types/account";
import React from "react";
import UINotificationBar from "~/old-ui/UINotificationBar";
import {clientStorageGet, clientStorageSet} from "~/utils";

export default function TrialNotificationBar({account, container}) {
  const accountId = account.id;

  const [hideTrialWarning, setHideTrialWarning] = React.useState(
    clientStorageGet(`account:${accountId}:settings:hideTrialWarning`)
  );

  const onWarningClose = React.useCallback(() => {
    setHideTrialWarning(true);
    clientStorageSet(`account:${accountId}:settings:hideTrialWarning`, true);
  }, [accountId, setHideTrialWarning]);


  switch (getTrialStatus(account)) {
    case 'ACTIVE':
      if (!isTrialUnlimited(account)) {
        const trialRemainingDays = getTrialRemainingDays(account);
        const isWarning = trialRemainingDays >= 7;

        const trialRemainingDaysRepr = {
          0: 'today',
          1: 'in 1 day'
        }[trialRemainingDays] || `in ${trialRemainingDays} days`;

        return (
          ((!isWarning || !hideTrialWarning) && (
            <UINotificationBar
              container={container}
              warning={isWarning}
              danger={!isWarning}
              closable={isWarning}
              onClose={isWarning ? onWarningClose : null}
            >
              Your trial will expire {trialRemainingDaysRepr}
            </UINotificationBar>
          ))
        );
      }
      break;

    case 'EXPIRED':
      return (
        <UINotificationBar container={container} danger>
          Your trial has expired.
        </UINotificationBar>
      );
  }

  return null;

}

TrialNotificationBar.fragments = {
  account: gql`
    fragment TrialNotificationBar on Account {
      id
      isTrial
      trial {
        status
        endsIn
      }
    }
  `
};
